export const IMAGE_CAPTURE_INTENTS = Object.freeze({
  SAVE_PHOTO: 'save_photo',
  CARE_DETAILS: 'care_details',
  READ_TEXT: 'read_text',
});

export const IMAGE_CAPTURE_INTENT_OPTIONS = Object.freeze([
  {
    value: IMAGE_CAPTURE_INTENTS.SAVE_PHOTO,
    label: 'Keep this photo',
    description: 'Save it with this entry',
    icon: 'save',
  },
  {
    value: IMAGE_CAPTURE_INTENTS.CARE_DETAILS,
    label: 'Find care info',
    description: 'Find useful care information',
    icon: 'care',
  },
  {
    value: IMAGE_CAPTURE_INTENTS.READ_TEXT,
    label: 'Read the words',
    description: 'Read text from a document, note, or screenshot',
    icon: 'document',
  },
]);

const IMAGE_CAPTURE_INTENT_VALUES = new Set(Object.values(IMAGE_CAPTURE_INTENTS));

export const normalizeImageCaptureIntent = (value) => (
  IMAGE_CAPTURE_INTENT_VALUES.has(value)
    ? value
    : IMAGE_CAPTURE_INTENTS.SAVE_PHOTO
);
